import { Pipe, PipeTransform } from "@angular/core";
import { ERROR_CODES_CONSTANTS } from "./error.code.constants";

@Pipe({ name: "errorMessage" })
export class errorMessagePipe implements PipeTransform {
  transform(value: string) {
    if (ERROR_CODES_CONSTANTS[value]) {
      return ERROR_CODES_CONSTANTS[value];
    } else {
      return value;
    }
  }
}
